import { render, staticRenderFns } from "./SchemaBuilder.vue?vue&type=template&id=08c103ee&scoped=true"
import script from "./SchemaBuilder.vue?vue&type=script&lang=js"
export * from "./SchemaBuilder.vue?vue&type=script&lang=js"
import style0 from "./SchemaBuilder.vue?vue&type=style&index=0&id=08c103ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c103ee",
  null
  
)

export default component.exports